import Vue from 'vue';
import { EnumUtility } from '@codequality/vue-cli-base';

import { PlbscfListItemConfig, RowCssClass, ValueType } from '@/master/Plbscf';
import { PlbscfListItem } from '@/classes/service/AbstractPlbscfService';
import { 実態BSListItem } from '@/classes/service/分析/実態BSService';

type State = {
  is要約表示: boolean;
};

const state = Vue.observable<State>({
  is要約表示: false,
});

export default Vue.extend({
  name: 'Plbscf要約表示Mixin',

  computed: {
    is要約表示: {
      get(): boolean {
        return state.is要約表示;
      },
      set(value: boolean) {
        state.is要約表示 = value;
      },
    },
  },

  methods: {
    rowCss(config: PlbscfListItemConfig): string {
      if (this.is要約表示 && config.rowCssClassIfSimple !== undefined) {
        return EnumUtility.valueToKey(RowCssClass, config.rowCssClassIfSimple);
      } else if (config.rowCssClass !== undefined) {
        return EnumUtility.valueToKey(RowCssClass, config.rowCssClass);
      } else {
        return '';
      }
    },
    filteredPlbscfListItems(list?: PlbscfListItem[]): PlbscfListItem[] {
      return this.$_filteredTargetListItems(list) as PlbscfListItem[];
    },
    filtered実態BSListItems(list?: 実態BSListItem[]): 実態BSListItem[] {
      return this.$_filteredTargetListItems(list) as 実態BSListItem[];
    },
    $_filteredTargetListItems(list?: (PlbscfListItem | 実態BSListItem)[]): (PlbscfListItem | 実態BSListItem)[] {
      if (list === undefined) return [];
      if (!this.is要約表示) return list;
      return list.filter(
        (listItem) =>
          listItem.config.valueType === ValueType.noValue ||
          listItem.config.valueType === ValueType.calcValueReadonly ||
          listItem.config.rowCssClassIfSimple !== undefined
      );
    },
  },
});
